
import BrandMetaService from "../../../common/services/meta/BrandMetaService";
import CategoryMetaService from "../../../common/services/meta/CategoryMetaService";
import PageMetaService from "../../../common/services/meta/PageMetaService";

import {
    GET_FILTERED_BRAND_METAS,
    GET_FILTERED_CATEGORY_METAS,
    GET_FILTERED_BRAND_METAS_NAME,
    GET_FILTERED_CATEGORY_METAS_NAME,
    GET_PAGE_METAS,
    GET_FILTERED_BRAND_META_TRANSLATIONS,
    GET_FILTERED_CATEGORY_META_TRANSLATIONS,
    GET_FILTERED_BRAND_META_TRANSLATIONS_NAME,
    GET_FILTERED_CATEGORY_META_TRANSLATIONS_NAME,
    GET_PAGE_META_TRANSLATIONS,
} from "./actions";

export default {

    state: {
        brandMetas: [
            {
                title: null,
                keyWords: null,
                description: null
            }
        ],

        categoryMetas: [
            {
                title: null,
                keyWords: null,
                description: null
            }
        ],

        brandMetasName: [
            {
                title: null,
                keyWords: null,
                description: null
            }
        ],

        categoryMetasName: [
            {
                title: null,
                keyWords: null,
                description: null
            }
        ],

        pageMetas: [
            {
                title: null,
                keyWords: null,
                description: null
            }
        ],

        brandMetaTrans: [
            {
                title: null,
                keyWords: null,
                description: null,
                languageCode: null,
            }
        ],

        categoryMetaTrans: [
            {
                title: null,
                keyWords: null,
                description: null,
                languageCode: null,
            }
        ],

        brandMetaTransName: [
            {
                title: null,
                keyWords: null,
                description: null,
                languageCode: null,
            }
        ],

        categoryMetaTransName: [
            {
                title: null,
                keyWords: null,
                description: null,
                languageCode: null,
            }
        ],

        pageMetaTrans: [
            {
                title: null,
                keyWords: null,
                description: null,
                languageCode: null,
            }
        ]
    },

    getters: {
        BrandMetas: (state) => state.brandMetas,
        CategoryMetas: (state) => state.categoryMetas,
        BrandMetasName: (state) => state.brandMetasName,
        CategoryMetasName: (state) => state.categoryMetasName,
        PageMetas: (state) => state.pageMetas,
        BrandMetaTrans: (state) => state.brandMetaTrans,
        CategoryMetaTrans: (state) => state.categoryMetaTrans,
        BrandMetaTransName: (state) => state.brandMetaTransName,
        CategoryMetaTransName: (state) => state.categoryMetaTransName,
        PageMetaTrans: (state) => state.pageMetaTrans,
    },

    mutations: {
        [GET_FILTERED_BRAND_METAS]: (state, data) => {
            state.brandMetas = data;
        },

        [GET_FILTERED_CATEGORY_METAS]: (state, data) => {
            state.caregoryMetas = data;
        },

        [GET_FILTERED_BRAND_METAS_NAME]: (state, data) => {
            state.brandMetasName = data;
        },

        [GET_FILTERED_CATEGORY_METAS_NAME]: (state, data) => {
            state.caregoryMetasName = data;
        },


        [GET_PAGE_METAS]: (state, data) => {
            state.pageMetas = data;
        },

        [GET_FILTERED_BRAND_META_TRANSLATIONS]: (state, data) => {
            state.brandMetaTrans = data;
        },

        [GET_FILTERED_CATEGORY_META_TRANSLATIONS]: (state, data) => {
            state.caregoryMetaTrans = data;
        },

        [GET_FILTERED_BRAND_META_TRANSLATIONS_NAME]: (state, data) => {
            state.brandMetaTransName = data;
        },

        [GET_FILTERED_CATEGORY_META_TRANSLATIONS_NAME]: (state, data) => {
            state.caregoryMetaTransName = data;
        },

        [GET_PAGE_META_TRANSLATIONS]: (state, data) => {
            state.pageMetaTrans = data;
        },
    },

    actions: {
        [GET_FILTERED_BRAND_METAS]: async (context, Ids) => {
            let brandMetaService = new BrandMetaService();
            let result = await brandMetaService.filteredBrandMetas(Ids);
            context.commit(GET_FILTERED_BRAND_METAS, result.data);
            return result;
        },

        [GET_FILTERED_CATEGORY_METAS]: async (context, Ids) => {
            let categoryMetaService = new CategoryMetaService();
            let result = await categoryMetaService.filteredCategoryMetas(Ids);
            context.commit(GET_FILTERED_CATEGORY_METAS, result.data);
            return result;
        },

        [GET_FILTERED_BRAND_METAS_NAME]: async (context, brandName) => {
            let brandMetaService = new BrandMetaService();
            let result = await brandMetaService.filteredBrandMetasByName(brandName);
            context.commit(GET_FILTERED_BRAND_METAS_NAME, result.data);
            return result;
        },

        [GET_FILTERED_CATEGORY_METAS_NAME]: async (context, categoryName) => {
            let categoryMetaService = new CategoryMetaService();
            let result = await categoryMetaService.filteredCategoryMetasByName(categoryName);
            context.commit(GET_FILTERED_CATEGORY_METAS_NAME, result.data);
            return result;
        },

        [GET_PAGE_METAS]: async (context, id) => {
            let pageMetaService = new PageMetaService;
            let result = await pageMetaService.getPageMetas(id);
            context.commit(GET_PAGE_METAS, result.data.data);
            return result;
        },

        [GET_FILTERED_BRAND_META_TRANSLATIONS]: async (context, Ids) => {
            let brandMetaService = new BrandMetaService();
            let result = await brandMetaService.filteredBrandMetaTrans(Ids);
            context.commit(GET_FILTERED_BRAND_META_TRANSLATIONS, result.data);
            return result;
        },

        [GET_FILTERED_CATEGORY_META_TRANSLATIONS]: async (context, Ids) => {
            let categoryMetaService = new CategoryMetaService();
            let result = await categoryMetaService.filteredCategoryMetaTrans(Ids);
            context.commit(GET_FILTERED_CATEGORY_META_TRANSLATIONS, result.data);
            return result;
        },

        [GET_FILTERED_BRAND_META_TRANSLATIONS_NAME]: async (context, brandName) => {
            let brandMetaService = new BrandMetaService();
            let result = await brandMetaService.filteredBrandMetaTransByName(brandName);
            context.commit(GET_FILTERED_BRAND_META_TRANSLATIONS_NAME, result.data);
            return result;
        },

        [GET_FILTERED_CATEGORY_META_TRANSLATIONS_NAME]: async (context, categoryName) => {
            let categoryMetaService = new CategoryMetaService();
            let result = await categoryMetaService.filteredCategoryMetaTransByName(categoryName);
            context.commit(GET_FILTERED_CATEGORY_META_TRANSLATIONS_NAME, result.data);
            return result;
        },

        [GET_PAGE_META_TRANSLATIONS]: async (context, id) => {
            let pageMetaService = new PageMetaService;
            let result = await pageMetaService.getPageMetaTrans(id);
            context.commit(GET_PAGE_META_TRANSLATIONS, result.data.data);
            return result;
        },

    },
};